import { render, staticRenderFns } from "./AcceptAction.vue?vue&type=template&id=22ad8bf0&scoped=true&"
import script from "./AcceptAction.vue?vue&type=script&lang=js&"
export * from "./AcceptAction.vue?vue&type=script&lang=js&"
import style0 from "./AcceptAction.vue?vue&type=style&index=0&id=22ad8bf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ad8bf0",
  null
  
)

export default component.exports